import './_vportal.js';

window.addEventListener("load", function () {
    const isMobile = $('body').data('device-type') === 'mobile';
    const fraction = $("#fraction");
    const slides = $("#nth-ms-news .swiper-slide");
    const slideCount = slides.length;
    fraction.find('.value').html(`1 / ${slideCount}`);

    if (isMobile) {
        // Dùng jQuery cho mobile, không cần sửa HTML
        let currentIndex = 0;
        let autoplayTimer = null;
        const $prevBtn = $('.swiper-banner-button-prev');
        const $nextBtn = $('.swiper-banner-button-next');
        const $slideEls = $('#nth-ms-news .swiper-slide');
        const $fractionValue = $('#fraction .value');
        const $swiperBanner = $('.swiper-banner');
        const $pagination = $('.swiper-banner-pagination');

        // Gán src cho img.swiper-lazy nếu có data-src
        $slideEls.find('img.swiper-lazy').each(function() {
            const $img = $(this);
            if (!$img.attr('src') && $img.attr('data-src')) {
                $img.attr('src', $img.attr('data-src'));
            }
        });
        // Ẩn preloader nếu có
        $slideEls.find('.swiper-lazy-preloader').hide();

        // Tạo pagination nếu chưa có
        if ($pagination.children().length !== slideCount) {
            $pagination.empty();
            for (let i = 0; i < slideCount; i++) {
                $pagination.append('<span class="swiper-pagination-bullet" data-index="' + i + '"></span>');
            }
        }
        const $bullets = $pagination.find('.swiper-pagination-bullet');

        function updatePagination(index) {
            $bullets.removeClass('active').eq(index).addClass('active');
        }

        function showSlide(index) {
            $slideEls.hide().eq(index).show();
            $fractionValue.text(`${index + 1} / ${slideCount}`);
            updatePagination(index);
        }
        function nextSlide() {
            currentIndex = (currentIndex + 1) % slideCount;
            showSlide(currentIndex);
        }
        function prevSlide() {
            currentIndex = (currentIndex - 1 + slideCount) % slideCount;
            showSlide(currentIndex);
        }
        function startAutoplay() {
            autoplayTimer = setInterval(nextSlide, 2000);
        }
        function stopAutoplay() {
            if (autoplayTimer) clearInterval(autoplayTimer);
        }

        // Touch event for swipe (jQuery style)
        let startX = 0;
        let isSwiping = false;
        $swiperBanner.on('touchstart', function(e) {
            if (e.originalEvent.touches.length === 1) {
                startX = e.originalEvent.touches[0].clientX;
                isSwiping = true;
            }
        });
        $swiperBanner.on('touchend', function(e) {
            if (!isSwiping) return;
            const endX = e.originalEvent.changedTouches[0].clientX;
            const diffX = endX - startX;
            if (Math.abs(diffX) > 40) { // threshold
                stopAutoplay();
                if (diffX < 0) {
                    nextSlide();
                } else {
                    prevSlide();
                }
                startAutoplay();
            }
            isSwiping = false;
        });

        // Click vào bullet để chuyển slide
        $pagination.on('click', '.swiper-pagination-bullet', function() {
            const idx = parseInt($(this).attr('data-index'));
            if (!isNaN(idx) && idx !== currentIndex) {
                stopAutoplay();
                currentIndex = idx;
                showSlide(currentIndex);
                startAutoplay();
            }
        });

        // Khởi tạo slide đầu tiên
        showSlide(currentIndex);
        startAutoplay();

        // Gán sự kiện nút
        $nextBtn.on('click', function(e) { e.preventDefault(); stopAutoplay(); nextSlide(); startAutoplay(); });
        $prevBtn.on('click', function(e) { e.preventDefault(); stopAutoplay(); prevSlide(); startAutoplay(); });

    } else {
        // Desktop: giữ nguyên Swiper
        const swiper = new Swiper(".swiper-banner", {
            preloadImages: false,
            lazy: true,
            autoplay: {
                delay: 2000,
            },
            navigation: {
                nextEl: ".swiper-banner-button-next",
                prevEl: ".swiper-banner-button-prev",
            },
            pagination: {
                el: ".swiper-banner-pagination",
                type: "progressbar",
            },
            on: {
                slideChange: function() {
                    fraction.find('.value').html(`${swiper.realIndex + 1} / ${slideCount}`);
                }
            }
        });
    }

    $(".news").each(function () {
        var postsTag = "#" + $(this).attr("id");
        console.log(postsTag);
        $().vPortal({
            container: postsTag,
            el: {
                tabContainer: '.news-tabs > a',
                resultContainer: '.news-list',
                viewAll: '.viewAll',
            },
            paginationOptions: {
            }
        });

    });

});